import Letterhead from "../Reusable/Letterhead2";
import MetaInfo from "../Reusable/MetaInfo2";
import SubjectLine from "../Reusable/SubjectLine2";
import Signature from "../Reusable/Signature2";

interface WarningLetterProps {
  refNo: string;
  date: string;
  name: string;
  address: string;
  lastDate: string;
}

const RelievingLetter = ({ refNo, date, name, address, lastDate }: WarningLetterProps) => (
  <div className="p-10 rounded-lg max-w-2xl mx-auto space-y-4">
    <Letterhead/>
    <hr className=" mx-auto w-4/4 border-t-2 border-black"/>
    <MetaInfo refNo={refNo} date={date} name={name} address={address} />
    <SubjectLine subject="Relieving letter" />

    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
    This letter is an official acknowledgment and confirmation of receiving your resignation
    letter dated <b>{date}</b> from your position of Content Executive at Optim Health and Wellness
    (OPC) Pvt. Ltd, and to confirm that you have been relieved from your duties effective <b>{lastDate}</b>.
    </p>
    <br/>
    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
    Your tenure with the organization from <b>{date}</b>, has been valuable, and we sincerely
    appreciate your contributions towards the company’s growth and success.
    </p>
    <br/>
    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
    Your full and final settlement has been processed. We request that you kindly return your
    company ID card and any other assets or property belonging to the organization that may
    have been issued to you during your period of employment.
    </p>
    <br/>
    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
    We thank you for your services and extend our best wishes for your future endeavours. May
    you continue to achieve success in your professional journey.
    </p>

    <Signature />
  </div>
);

export default RelievingLetter;
